//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
import { api_SaveClientSeed, api_GetSeeds, api_CaseBattleLogDetail } from "@/api";

export default {
    name: "boxBattleHistory",
    data() {
        return {
            historyData: {
                data: { list: [], total: 0 },
                current: 1,
                size: 15,
            },
            clientSeed: "",
            savingSeed: false,
            expandedRooms: {},
        };
    },
    methods: {
        ...mapMutations(["setInfo"]),
        async getSeeds() {
            try {
                const res = await api_GetSeeds();
                if (res.data.code === 0) {
                    const data = res.data.data || {};
                    this.clientSeed = data.clientHashSeed || "";
                }
            } catch (error) {
                console.error("Failed to fetch seeds:", error);
            }
        },
        async saveClientSeed() {
            if (!this.clientSeed) {
                this.$toast.error("请输入客户端种子");
                return;
            }
            this.savingSeed = true;
            try {
                const res = await api_SaveClientSeed({ clientSeed: this.clientSeed });
                if (res.data.code === 0) {
                    this.$toast.success("保存成功");
                    this.setInfo();
                    this.getSeeds();
                } else {
                    this.$toast.error(res.data.msg || "保存失败");
                }
            } catch (error) {
                this.$toast.error("网络错误");
            } finally {
                this.savingSeed = false;
            }
        },
        openThirdPartyVerify() {
            window.open("https://sharplab.io/#v2:C4LgTgrgdgNAJiA1AHwAICYCMBYAUKgBgAJVMA6AZQFMBjCMAS2AE8yBhMZgB2AHsBzMAEMuAC2YBuPIRLkAKlQAewKbmmZiAZypgAbjupU4RALxEAROYkB6a4GsNQJmKgWHNAhUqALNUCznoAVtdcRoAbBiooYENjM0sbewdAIu1AdiNAe69vXyIoXigaKlMLKyJbIkdAcr1AWXlAd+U8BhCiPmAhfwAlISh+LLMCCTzrAodARu8vQBC3QABzQHJNMF5/f0AeBQqqgCMhYGB/KnreXgBbAElwonbO7sB+I0AX1PLcSuAiGiFtbey9/Mc+zYARPAqAMwAKbT0DKiMTCZLMhkAEgiEwoDgcg0hkqFDzCCanVGs0qAAeEwEEHzRbLVYbbaY7Gg65UIlYgCUeAA3ngiAzZABOT7mQDv0Y5ADHagBdTQBDyoAHU3MlNUjJIAHZVABfN74DSXDazSpGCjARjNbIAEnMNNxSxWay2cElAFoaVcbkbTWDgqF/paabDMpKrClRNdRNkABIAWQAgmwKJ7fegAKwANk+NAVSrgKrV/BgRB++jAYWFMtIxDdmlEAAUwFR3gxFNls6JKBBZpnPgREwAOdO4CDnIhlgBqdQgrSIbHSKeAZDkvAAqpsQgBmdCfMv5wvFxOYMONvBwXiV5apXhgdZ1BgALyMHf8Xeyn1X66olPbnayXWbITI3qEiiPXdUMwuBc0EH8FzMn3OSkn2AcsADF/DWMBPjSbddwPOBXyyAAqapeFqBomhaZczneIhPi/H8LnRXZKSIAjfzuVQGFw/CqG/CiAD4zGRDC0VI8i/1Q9DURaIhjSITB31lFlzEAZb9ABzzQB6M0ALH/zEQDjsPUMNZGIH1/UDYNw0+TMiDgBYhETHSAGsqGYalcDpXBRVmZhgCoABtABdIgbLs559OyABRDJeDgSp+DIYc5FAusyAAcSoYAACFbLos99MbazYqclzYoAaVMryfL85pAuC0KIui2LNE+EyzJFRldCEMBWx3GgcyEUNlLMKAqAAdyINSAyDJrPlcqgMvK+lGX6lKONLOqGqa9gNi4CA7M9d0+ti9zakSxlUDFIgoqYXsoH7HRB14ON/No+jgEpMh6ioLh/CETJWWNcxE0sS6hwAGV4NqdE+RtJSAA=", "_blank");
        },
        buildParams(page = this.historyData.current) {
            return {
                page,
                size: this.historyData.size,
            };
        },
        getField(source, ...keys) {
            if (!source) return null;
            for (const key of keys) {
                if (source[key] !== undefined && source[key] !== null) {
                    return source[key];
                }
            }
            return null;
        },
        normalizeCase(item = {}) {
            return {
                id: this.getField(item, "id", "Id"),
                caseName: this.getField(item, "caseName", "CaseName"),
                casePic: this.getField(item, "casePic", "CasePic"),
            };
        },
        normalizeDetail(item = {}) {
            return {
                id: this.getField(item, "id", "Id"),
                battleRoomId: this.getField(item, "battleRoomId", "BattleRoomId"),
                battleCount: this.getField(item, "battleCount", "BattleCount"),
                caseBattleId: this.getField(item, "caseBattleId", "CaseBattleId"),
                caseBattleName: this.getField(item, "caseBattleName", "CaseBattleName"),
                caseItemName: this.getField(item, "caseItemName", "CaseItemName"),
                createTime: this.getField(item, "createTime", "CreateTime"),
                fairNonce: this.getField(item, "fairNonce", "FairNonce"),
                fairRoll: this.getField(item, "fairRoll", "FairRoll"),
                fairMaxRoll: this.getField(item, "fairMaxRoll", "FairMaxRoll"),
                fairClientSeed: this.getField(item, "fairClientSeed", "FairClientSeed"),
            };
        },
        normalizePlayer(item = {}) {
            const details = this.getField(item, "details", "Details");
            return {
                memberId: this.getField(item, "memberId", "MemberId", "userId", "UserId"),
                userId: this.getField(item, "userId", "UserId"),
                name: this.getField(item, "name", "Name"),
                avatar: this.getField(item, "avatar", "Avatar"),
                isCurrentUser: Boolean(this.getField(item, "isCurrentUser", "IsCurrentUser")),
                isWinner: Boolean(this.getField(item, "isWinner", "IsWinner")),
                details: Array.isArray(details) ? details.map((detail) => this.normalizeDetail(detail)) : [],
            };
        },
        normalizeRoom(item = {}, index = 0) {
            const cases = this.getField(item, "cases", "Cases");
            const players = this.getField(item, "players", "Players");
            const id = this.getField(item, "id", "Id");
            const battleRoomId = this.getField(item, "battleRoomId", "BattleRoomId");

            return {
                id,
                rowKey: String(battleRoomId || id || "room") + "-" + index,
                battleRoomId,
                createTime: this.getField(item, "createTime", "CreateTime"),
                serverSeedHash: this.getField(item, "serverSeedHash", "ServerSeedHash"),
                serverSeed: this.getField(item, "serverSeed", "ServerSeed", "fairServerSeed", "FairServerSeed"),
                cases: Array.isArray(cases) ? cases.map((caseItem) => this.normalizeCase(caseItem)) : [],
                players: Array.isArray(players) ? players.map((player) => this.normalizePlayer(player)) : [],
            };
        },
        async getList(page = this.historyData.current) {
            try {
                const res = await api_CaseBattleLogDetail(this.buildParams(page));
                if (res.data.code === 0) {
                    const payload = res.data.data || {};
                    const list = this.getField(payload, "data", "Data");
                    this.historyData.data.list = Array.isArray(list) ? list.map((item, index) => this.normalizeRoom(item, index)) : [];
                    this.historyData.data.total = this.getField(payload, "totalItems", "TotalItems") || 0;
                    this.historyData.current = this.getField(payload, "pageNumber", "PageNumber") || page;
                    this.historyData.size = this.getField(payload, "pageSize", "PageSize") || this.historyData.size;
                    this.expandedRooms = {};
                } else {
                    this.$toast.error(res.data.msg || "获取盒战记录失败");
                }
            } catch (error) {
                this.$toast.error("网络错误");
            }
        },
        pageF(v) {
            this.getList(v);
        },
        toggleRoom(room) {
            const key = this.getRoomExpandKey(room);
            this.$set(this.expandedRooms, key, !this.expandedRooms[key]);
        },
        isRoomExpanded(room) {
            return Boolean(this.expandedRooms[this.getRoomExpandKey(room)]);
        },
        getRoomExpandKey(room) {
            return room && (room.battleRoomId || room.id || room.rowKey);
        },
        getPlayerInitial(name) {
            return name ? String(name).slice(0, 1).toUpperCase() : "-";
        },
        async copyValue(value, successMessage) {
            if (!value) return;
            try {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(String(value));
                } else {
                    const input = document.createElement("input");
                    input.value = String(value);
                    input.readOnly = true;
                    document.body.appendChild(input);
                    input.select();
                    document.execCommand("copy");
                    document.body.removeChild(input);
                }
                this.$toast.success(successMessage || "已复制");
            } catch (error) {
                this.$toast.error("复制失败");
            }
        },
        displayValue(value) {
            return value === 0 || value === "0" || value ? value : "-";
        },
        getServerSeedPreview(seed) {
            if (!seed) return "-";
            const text = String(seed);
            return text.length > 8 ? `${text.slice(0, 8)}...` : text;
        },
    },
    created() {
        this.getSeeds();
        this.getList();
    },
};
